import * as React from "react";

interface IosIconProps {
	fillColor: string;
	iconColor: string;
	style: any;
}

const IosIcon = (props: IosIconProps) => (
	<svg width="15px" height="19px" viewBox="0 0 15 19" version="1.1" style={props.style}>
		<defs />
		<g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
			<g id="Main" transform="translate(-84.000000, -98.000000)" fill="#FFFFFF">
				<g id="Group" transform="translate(22.000000, 98.000000)">
					<g id="Page-1" transform="translate(62.000000, 0.000000)">
						<path
							d="M7.50060405,4.21385286 C7.28631779,3.14242155 7.87793421,2.07099023 8.42962152,1.38753683 C9.13303947,0.5610041 10.2450654,-3.55271368e-15 11.2040297,-3.55271368e-15 C11.2652543,1.07143132 10.8772764,2.12223259 10.1838407,2.88754068 C9.561612,3.71407341 8.49018068,4.33630216 7.50060405,4.21385286 M14.5307907,6.27486081 C14.448936,6.32610318 12.500395,7.40751678 12.500395,9.80526028 C12.592232,12.5397393 14.9593632,13.4987036 14.9999578,13.4987036 C14.9593632,13.549946 14.6425922,14.8050513 13.7042579,16.1207157 C12.9595799,17.2540371 12.1330472,18.3966754 10.8779419,18.3966754 C9.68406129,18.3966754 9.25548876,17.6413496 7.87793421,17.6413496 C6.39856041,17.6413496 5.97997016,18.3966754 4.8473142,18.3966754 C3.59220894,18.3966754 2.70445156,17.1928125 1.91917891,16.0701388 C0.898989963,14.6007473 0.0318626282,12.2948408 0.00125030478,10.0807712 C-0.0193797393,8.90752062 0.205554289,7.75423461 0.776540669,6.77464026 C1.58244336,5.40706799 3.02122256,4.47871601 4.59243333,4.44810369 C5.79629622,4.40750908 6.86772754,5.27463642 7.6024233,5.27463642 C8.30650674,5.27463642 9.62283664,4.44810369 11.1121927,4.44810369 C11.7550515,4.44876917 13.4693416,4.64242539 14.5307907,6.27486081"
							id="Fill-1"
						/>
					</g>
				</g>
			</g>
		</g>
	</svg>
);

export default IosIcon;



// WEBPACK FOOTER //
// ./src/components/PlatformSelector/IosIcon.tsx